import {
	WeaTools
} from 'ecCom'

export const isAdmin = params => {
	return WeaTools.callApi('/api/hrm/resource/isAdmin', 'GET', params);
}

export const getResourceBaseTitle = params => {
	return WeaTools.callApi('/api/hrm/resource/getResourceBaseTitle', 'GET', params);
}

export const getHrmResourceTab4Formal = params => {
	return WeaTools.callApi('/api/hrm/resource4formal/getHrmResourceTab', 'GET', params);
}

export const getHrmResourceTab = params => {
	return WeaTools.callApi('/api/hrm/resource/getHrmResourceTab', 'GET', params);
}

export const getResourceCard = params => {
	return WeaTools.callApi('/api/hrm/resource/getResourceCard', 'GET', params);
}

export const editResource = params => {
	return WeaTools.callApi('/api/hrm/resource/editResource', 'POST', params);
}

export const saveRemark = (params = {}) => WeaTools.callApi('/api/hrm/resource4formal/saveRemark', 'POST', params)

export const saveTag = (params = {}) => WeaTools.callApi('/api/hrm/resource4formal/saveTag', 'POST', params)

export const delTag = (params = {}) => WeaTools.callApi('/api/hrm/resource4formal/delTag', 'POST', params)

export const uploadPortrailAuth = (params = {}) => WeaTools.callApi('/api/hrm/usericon/getHasRight', 'GET', params)

export const saveUserIcon = (params = {}) => WeaTools.callApi('/api/hrm/usericon/saveUserIcon', 'POST', params)


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/card.js